import {getContentProvider, getCurrentContent} from "./content_module";
import {ActionContext} from "vuex";
import {PlayerState} from "./player";
import {ScormCheckpoint} from "../../../../presentation/views/content/helpers";

export class CheckpointState {}

const state = new CheckpointState();
type ProgressActionContext = ActionContext<CheckpointState, PlayerState>;

const mutations = {};

const actions = {
  async saveCheckpointSeconds(ctx: ProgressActionContext, timestamp: number) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      await provider.saveCheckpointSeconds(content.id, timestamp);
    } catch (e) {
      console.error("[saveCheckpointSeconds] Error SET_CHECKPOINT_INTERVAL", e);
      throw e;
    }
  },

  async saveCheckpointSCORM(ctx: ProgressActionContext, scormCheckpoint: ScormCheckpoint) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      await provider.saveCheckpointSCORM(content.id, scormCheckpoint);
    } catch (e) {
      console.error("[saveCheckpointSCORM] Error ", e);
      throw e;
    }
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}